
import Vue, { CreateElement, VNode } from "vue";
import { FormField, FormValue } from "@/types";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { VTextField } from "vuetify/lib";
import { getFieldProps, mergeProps } from "@/lib/helpers/fieldHelpers";

@Component({ name: "InputPassword" })
export default class InputPassword extends Vue {
  @Prop({ required: true })
  public readonly field!: FormField;

  @Prop({ required: true })
  public readonly value!: FormValue;

  @Prop()
  public readonly fieldError!: string[] | undefined;

  public showPassword: boolean = false;

  public render(h: CreateElement): VNode {
    const props = mergeProps(getFieldProps(this.field, this.value), {
      ["appendIcon"]: this.showPassword ? "visibility" : "visibility_off",
      ["type"]: this.showPassword ? "text" : "password",
      ["error"]: !!this.fieldError,
      ["error-messages"]: this.fieldError,
    });
    return h(VTextField, {
      ref: "textField",
      props,
      attrs: { autocomplete: this.field.browserAutocomplete },
      on: {
        ["click:append"]: () => (this.showPassword = !this.showPassword),
        ["input"]: (v: FormValue) => this.$emit("input", v),
        ["keydown"]: (e: KeyboardEvent) => this.$emit("keydown", e),
      },
    });
  }
}
